import { WebAPI } from "../constants";
import AuthService from "../../common/AuthService";
import download, { ICallbackParams } from "./downloadCommon";

export interface IDownloadFkdppModelParams extends ICallbackParams {
  /**
   * 認証オブジェクト
   */
  authService?: AuthService;
  /**
   * プロジェクトID
   */
  projectid: string;
  /**
   * モデルID
   */
  modelid: string;
  /**
   * 作成ファイル名
   */
  filename: string;
}

/**
 * 設定ファイルをダウンロードします
 * @function downloadFkdppModel
 * @param {IDownloadFkdppModelParams} params - 設定ファイルダウンロードパラメータ
 */
export function downloadFkdppModel(params: IDownloadFkdppModelParams): void {
  const { authService, projectid, modelid, filename } = params;
  const url = WebAPI.DOWNLOAD_FKDPPMODEL(projectid, modelid);
  download(url, filename, params, authService);
}